/* eslint-disable */
import { Card } from 'antd';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 16px 0;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`;

export const DictionaryItem = styled(Card)`
  cursor: pointer;
  transition: all 0.3s;
  height: 100%;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const CardTitle = styled.h4`
  margin: 0 0 8px 0;
  font-size: 15px;
  font-weight: 600;
  color: #1890ff;
`;

export const CardDescription = styled.div`
  margin-top: 8px;
  color: #666;
  font-size: 13px;
  line-height: 1.5;
`;

export const typeLabels = {
  general: { text: 'Общий', color: 'blue' },
  queues: { text: 'Для очередей', color: 'orange' },
};

export const DictionaryContent = styled.div`
  margin-top: 16px;
  padding: 16px;
  background: #f5f5f5;
  border-radius: 4px;
  max-height: 400px;
  overflow-y: auto;
`;

export const ContentItem = styled.div`
  padding: 8px;
  margin-bottom: 8px;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #e6f7ff;
  }
  ${(props) => props.selected && `
  background: #1890ff;
  color: white;
  `}
`;

export const ControlsWrapper = styled.div`
  margin-top: 16px;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
`;

export const PreviewWrapper = styled.div`
  margin-top: 16px;
  padding: 16px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
`;

export const PreviewTitle = styled.h4`
  margin: 0 0 12px 0;
  color: #1890ff;
`;

export const PreviewItem = styled.div`
  margin-bottom: 12px;
  padding: 12px;
  background: white;
  border-radius: 4px;
  
  strong {
    color: #666;
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
  }
  
  code {
    display: block;
    padding: 8px;
    background: #f5f5f5;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    word-break: break-all;
  }
`;
